import script from "./ExamResultSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamResultSummary.vue?vue&type=script&setup=true&lang=js"

import "./ExamResultSummary.vue?vue&type=style&index=0&id=660be952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660be952"]])

export default __exports__